<div class="asset-navigation-container">
  <div class="asset-navigation fwe-br">
    @if (showOpenButton) {
      <div class="menu-item-container">
        <a
          [routerLink]="['', { outlets: { asset: ['tree', AssetStateEnum.OPEN, AssetStateEnum.REGULAR], primary: ['machines'] } }]"
          [routerLinkActive]="['fwe-color-hero', 'active']"
          [routerLinkActiveOptions]="{ exact: false }"
          [fngTooltip]="'MACHINES.TOOLTIPS.ASSET_TREE' | translate"
          [fngTooltipPositions]="['right']"
          (click)="switchToCloseIfOpen(isAssetOpen)"
          data-smrtnc-test="asset-layout--tree"
          >
          <i class="fwe-icon fwe-icon-lg fwe-icon-file-project-structure"></i>
        </a>
        <a
          [routerLink]="['', { outlets: { asset: ['tree', AssetStateEnum.ALL_MACHINES], primary: ['machines'] } }]"
          [fngTooltip]="'MACHINES.TOOLTIPS.MACHINES' | translate"
          [fngTooltipPositions]="['right']"
          [ngClass]="{ 'fwe-color-hero active': isRegularMachineZone }"
          data-smrtnc-test="asset-layout--all"
          >
          <i class="fwe-icon fwe-icon-lg fwe-icon-list-list-view"></i>
        </a>
        <a
          *smaWebFeatureOn="LicenseFeatureFlag.SAP"
          [routerLink]="['', { outlets: { asset: ['tree', AssetStateEnum.OPEN, AssetStateEnum.SAP], primary: ['sap', 'machines'] } }]"
          [routerLinkActive]="['fwe-color-hero', 'active']"
          [routerLinkActiveOptions]="{ exact: false }"
          [fngTooltip]="'SAP.TOOLTIPS.SAP_ASSET_TREE' | translate"
          [fngTooltipPositions]="['right']"
          (click)="switchToCloseIfOpenSap(isAssetOpen)"
          data-smrtnc-test="asset-layout--sap-tree"
          >
          <i class="fwe-icon fwe-icon-lg fwe-icon-file-project-structure"></i>
          <i [routerLinkActive]="['fwe-icon-sap-horizontal']" class="fwe-icon fwe-icon-lg fwe-icon-sap-black-horizontal sap-icon-position fwe-ml-1"></i>
        </a>
        <a
          *smaWebFeatureOn="LicenseFeatureFlag.SAP"
          [routerLink]="['', { outlets: { asset: ['tree', AssetStateEnum.ALL_SAP_MACHINES], primary: ['sap', 'machines'] } }]"
          [routerLinkActive]="['fwe-color-hero', 'active']"
          [fngTooltip]="'SAP.TOOLTIPS.SAP_MACHINES' | translate"
          [fngTooltipPositions]="['right']"
          data-smrtnc-test="asset-layout--sap-all"
          >
          <i class="fwe-icon fwe-icon-lg fwe-icon-list-list-view fwe-position-relative"></i>
          <i [routerLinkActive]="['fwe-icon-sap-horizontal']" class="fwe-icon fwe-icon-lg fwe-icon-sap-black-horizontal sap-icon-position fwe-ml-1"></i>
        </a>
      </div>
    }

    @if (showExportMenu) {
      <div class="menu-item-container">
        <a
          [routerLink]="['/export', 'files-list']"
          [routerLinkActive]="['fwe-color-hero', 'active']"
          [fngTooltip]="'EXPORT.TOOLTIPS.EXPORT_TAB' | translate"
          [fngTooltipPositions]="['right']"
          data-smrtnc-test="export-layout--export"
          >
          <i class="fwe-icon fwe-icon-lg fwe-icon-file-export"></i>
        </a>
        <a
          *smaWebFeatureOn="LicenseFeatureFlag.DIGI_LOG"
          [routerLink]="['/export', 'reports-list']"
          [routerLinkActive]="['fwe-color-hero', 'active']"
          [fngTooltip]="'EXPORT.TOOLTIPS.EXPORT_MTTR_TAB' | translate"
          [fngTooltipPositions]="['right']"
          data-smrtnc-test="export-layout--export-mttr"
          >
          <i class="fwe-icon fwe-icon-lg fwe-icon-documents-datasheet"></i>
        </a>
      </div>
    }
  </div>

  <div class="asset-tree-main-container">
    <div class="asset-tree-header-spacer"></div>
    <router-outlet name="asset" />
  </div>
</div>
